<template>
	<form @submit="onSubmit" id="LoginForm" class="login">
		<div class="col-12 mb-2">
			<label for="code">کد ملی</label>
			<input type="text" class="form-control" id="nationalCode"
				   inputmode="numeric"
				   v-model="nationalCode"
				   data-label="کد ملی"
				   data-validations='["required","nationalcode"]' />
		</div>
		<div class="col-12 mb-2">
			<label for="password">کلمه عبور</label>
			<input type="password" class="form-control" id="password"
				   v-model="password"
				   data-label="کلمه عبور"
				   data-validations='["required","password"]' />
		</div>
		<div class="col-12 mb-2">
			<h6 class="forget pt-2" @click="$emit('stateChanged', 'forgot-password')">
				کلمه عبور خود را فراموش کرده اید؟
			</h6>
			<div class="form-check">
				<input class="form-check-input" type="checkbox" v-model="rememberMe" id="flexCheckDefault" />
				<label class="form-check-label" for="flexCheckDefault">
					مرا به خاطر بسپار
				</label>
			</div>
		</div>
		<div class="col-12">
			<div class="alert alert-warning m-0" v-if="warnings.length">
				<ul>
					<li v-for="warning in warnings">
						{{ $t(warning.type,{label:warning.label}) }}
					</li>
				</ul>
			</div>
			<div class="alert alert-danger m-0" v-if="errors.length">
				<ul>
					<li v-for="error in errors">
						{{ $t(error.type) }}
					</li>
				</ul>
			</div>
		</div>
		<div class="col-12">
			<button class="btn btn-login mt-2 " type="submit" v-bind:disabled="loading">
				<span v-if="!loading"> ورود </span>
				<span v-if="loading" class="spinner-border spinner-border-sm"></span>
			</button>
		</div>
		<div class="col-12">
			<p @click="$emit('stateChanged', 'register')">ایجاد حساب کاربری</p>
		</div>
	</form>
</template>

<script>
	import store from "@/common/store";
	import utility from '@/plugins/utility';
	const form = new utility.form('#LoginForm');
	const db = new utility.db();

	export default {
		emits: ["stateChanged"],
		data()
		{
			return {
				loading: false,
				rememberMe: false,
				warnings: [],
				errors: [],
				nationalCode: '',
				password: ''
			}
		},

		methods: {

			gotoClub()
			{
				this.request('/api/Club/GetCustomerInfo', null, (response) =>
				{
					if (response)
					{
						store.customer = response
						const redirectPath = this.$route.query.redirect || "/club/dashboard";
						this.$router.push(redirectPath);
					}
					else
					{
						this.errors = [{ type: 'errors.server' }];
					}

				}, 'get');
			},


			onSubmit(evt)
			{
				evt.preventDefault()
				this.warnings = form.errors();
				this.errors = [];

				if (this.warnings.length == 0)
				{
					this.request('/api/CustomerAuth/Login', { NationalCode: this.nationalCode, PassWord: this.password }, (response) =>
					{
						if (response.success)
						{
							store.customer = response.meta.customer
							if (this.rememberMe)
								db.insert('__c', response.meta.customer)

							this.loading = true;

							axios({
								method: 'post',
								url: '/login',
								headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
								data: 'username=' + this.nationalCode + '&password=' + this.password + '&grant_type=password&customer=1'
							})
								.then(response =>
								{
									this.loading = false;
									if (response.data !== undefined)
									{
										if (response.data.access_token !== undefined)
										{
											store.token = response.data
											if (this.rememberMe)
												db.insert('__t', response.data);

											axios.defaults.headers.common['Authorization'] =
												'Bearer ' + store.token.access_token;

											this.gotoClub()
											return;
										}
									}

									this.errors = [{ type: 'errors.server' }];
								})
								.catch(error =>
								{
									this.loading = false;
									this.errors = [{ type: 'errors.server' }];
								});

							return;
						}

						this.warnings = [{ type: 'validation.login' }];
					})
				}
			},

			request(url, data, succees, method)
			{
				this.loading = true;
				axios({
					method: method || 'post',
					url: url,
					data: data
				})
					.then(response =>
					{
						this.loading = false;
						succees(response.data)
					})
					.catch(error =>
					{
						this.errors = [{ type: 'errors.server' }];
						this.loading = false;
					});
			}
		}
	};
</script>
<style>

	.rasa-auth .content .btn-login {
		background-color: #ffc600;
		width: 100%;
		height: 45px;
		margin-bottom: 10px;
		transition: all .5s;
	}

		.rasa-auth .content .btn-login:hover {
			box-shadow: 0px 0px 10px 0px #ddd;
			background: #fff;
			color: #ffc600;
		}

	.rasa-auth .content p {
		box-shadow: 0px 0px 3px 0px #ddd;
		padding: 10px 0;
		cursor: pointer;
		text-align: center;
	}
</style>
